import { OrderQueryScopeEnum } from 'src/app/core/enums/order-query-scope.enum';
import { FrontlineDocumentComponent } from './../../components/frontline-document/frontline-document.component';
import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { UserPreferenceConstants } from 'src/app/core/constants/user-preference-constants.constant';
import { FileCategory } from 'src/app/core/constants/file-category.constant';
import { DateTableColumn } from 'src/app/core/models/date-table-column';
import { DateViewColumn } from 'src/app/core/models/date-view-column';
import { LaasOption } from 'src/app/core/models/laas-option';
import { FacilityOptions } from 'src/app/core/models/options/facility-options';
import { PageInfo } from 'src/app/core/models/page-info';
import { PageResp } from 'src/app/core/models/page/page-response';
import { ShipmentProgressSearchParams } from 'src/app/core/models/transport-operation/shipment-progress-search-params';
import { ShipmentSearchResult } from 'src/app/core/models/transport-operation/shipment-search-result';
import { DropdownOptionsService } from 'src/app/core/services/dropdown-options.service';
import { getDataScopeByPermission, isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { copyFormControl } from 'src/app/core/utils/validation-functions';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { DeliveryOrderService } from 'src/app/features/transport-operation/services/delivery-order.service';
import { DataTableComponent } from 'src/app/shared/components/data-table/data-table.component';
import { endOfDay, startOfDay } from 'date-fns';
import { FileManagementComponent } from '../../components/file-management/file-management.component';
import { ActivatedRoute, Params } from '@angular/router';
import { CommonDataService } from 'src/app/core/services/common-data.service';
import { CodeConverterOptions } from 'src/app/core/models/options/code-converter-options';
import { CalendarComponent } from 'src/app/shared/components/calendar/calendar.component';
import { CustomerDropdownComponent } from 'src/app/shared/components/dropdowns/customer-dropdown/customer-dropdown.component';
import { FacilityDropdownComponent } from 'src/app/shared/components/dropdowns/facility-dropdown/facility-dropdown.component';

@Component({
  selector: 'laas-shipment-progess-search',
  templateUrl: './shipment-progess-search.component.html',
  styleUrls: ['./shipment-progess-search.component.scss']
})
export class ShipmentProgessSearchComponent extends SessionBaseComponent implements OnInit {

  readonly preferenceKey: string = UserPreferenceConstants.ShipmentProgressSearchResult;
  readonly permissionCode: PermissionConstants = PermissionConstants.ViewQueryDoStatus;
  currentLang: string = this.laasSetting.language;
  readonly deliveryOrderFileCategory: FileCategory = FileCategory.DeliveryOrder;
  protected readonly OrderQueryScopeEnum = OrderQueryScopeEnum;

  defaultEstimateLeaveDt: Date[];
  searchForm!: FormGroup;
  isSearchFormOpen: boolean;
  searchParams: ShipmentProgressSearchParams = new ShipmentProgressSearchParams();
  results: ShipmentSearchResult[] = [];
  dataViewColumns: DateViewColumn[] = [];
  dataTableColumns: DateTableColumn[] = [];
  DOStatusOptions: LaasOption[] = [];
  selectedRows: ShipmentSearchResult[] = [];
  isShowFileManagement: boolean = false;
  isShowTaskDocManagement: boolean = false;
  pageInfo: PageInfo;
  sortInfo: { property: string, direction: number } | null;
  @ViewChild(DataTableComponent) table!: DataTableComponent;
  @ViewChild('fileManagement') fileManagement!: FileManagementComponent;
  @ViewChild('frontLineDoc') frontlineDoc!: FrontlineDocumentComponent;
  @ViewChild('customerOptions') customerOptions!: CustomerDropdownComponent;
  noShippingReasonOptions: Array<LaasOption> = [];
  frontLineDocStatusOptions: LaasOption[] =[];
  customDocTypeOptions: LaasOption[] = [];
  extraWorkStatusOptions: LaasOption[] = [];

  first: number;

  @ViewChild('invoiceDt') invoiceDt!: CalendarComponent;
  @ViewChild('leaveWarehouseDt') leaveWarehouseDt!: CalendarComponent;
  @ViewChild('estimateLeaveDt') estimateLeaveDt!: CalendarComponent;
  @ViewChild('facility') facility!: FacilityDropdownComponent;

  fileCategoryForTaskDoc: FileCategory = FileCategory.FrontLine;
  canEditTable: boolean = false;
  canUploadDoc: boolean = false;
  canConfirm: boolean = false;
  uploadFileType: string = "";

  constructor(
    injector: Injector,
    private fb: FormBuilder,
    private dropdownOptionService: DropdownOptionsService,
    private DOService: DeliveryOrderService,
    private route: ActivatedRoute,
    private commonDataService: CommonDataService
  ) {
    super(injector);

    this.defaultEstimateLeaveDt = [startOfDay(new Date()), endOfDay(new Date())];

    this.searchForm = this.fb.group({
      orderQueryScope: this.OrderQueryScopeEnum.all,
      orderStatus: 3,
      consigneeCompany: "",
      selectedFacility: [[]],
      doNos: [[]],
      estimateLeaveDtStart: startOfDay(new Date()),
      estimateLeaveDtEnd: endOfDay(new Date()),
      invoiceNos: [[]],
      invoiceDtStart: null,
      invoiceDtEnd: null,
      leaveWarehouseDtStart: null,
      leaveWarehouseDtEnd: null,
      salesCodes: [[]],
      csr: "",
      ajb: null,
      orgIds: [[]],
      mergeKeys: [[]],
      customerPOs: [[]],
      frontLineDocStatus:  [[]]
    });

    this.isSearchFormOpen = true;

    this.first = 0;

    this.sortInfo = null;

    this.pageInfo = { pageSize: 5, pageIndex: 0, totalRecords: 0, totalPages: 0 };

    const dataTablePreference = this.getDataTablePreference(this.preferenceKey);
    this.sortInfo = isNullOrEmpty(dataTablePreference?.state?.sortField) || isNullOrEmpty(dataTablePreference?.state?.sortOrder) ? null :
      { property: dataTablePreference?.state?.sortField, direction: dataTablePreference?.state?.sortOrder };

    this.dataViewColumns = [
      { field: 'facility', header: 'ShippingStatus.MainTable.Facility' },
      { field: 'doNo', header: 'ShippingStatus.MainTable.DONum' },
      { field: 'consigneeKey', header: 'ShippingStatus.MainTable.Customer' },
      { field: 'cartonCnt', header: 'ShippingStatus.MainTable.NumCartons' },
      { field: 'doStatus', header: 'ShippingStatus.MainTable.Status' },
      { field: 'estimatedLeaveWarehouseDt', header: 'ShippingStatus.MainTable.EstimateLeave', dataType: 'date' },
      { field: 'fixedEstimatedLeaveWarehouseDt', header: 'ShippingStatus.MainTable.ReEsitmate', dataType: 'date' },
      { field: 'leaveWarehouseDt', header: 'ShippingStatus.MainTable.ActualLeave', dataType: 'date' },
      { field: 'fixedRemark', header: 'ShippingStatus.MainTable.Remarks' },
      { field: 'reasons', header: 'ShippingStatus.MainTable.Remarks' },
      { field: 'extraWorkStatus', header: 'ShippingStatus.MainTable.ExtraWorkStatus'},
    ];

    this.dataTableColumns = [
      { field: 'facility', header: 'ShippingStatus.MainTable.Facility', sort: true },
      { field: 'doNo', header: 'ShippingStatus.MainTable.DONum', sort: true },
      { field: 'consigneeKey', header: 'ShippingStatus.MainTable.Customer', sort: true },
      { field: 'cartonCnt', header: 'ShippingStatus.MainTable.NumCartons', sort: true },
      { field: 'doStatus', header: 'ShippingStatus.MainTable.Status', sort: true },
      { field: 'estimatedLeaveWarehouseDt', header: 'ShippingStatus.MainTable.EstimateLeave', dataType: 'date', sort: true },
      { field: 'fixedEstimatedLeaveWarehouseDt', header: 'ShippingStatus.MainTable.ReEsitmate', dataType: 'date', sort: true },
      { field: 'leaveWarehouseDt', header: 'ShippingStatus.MainTable.ActualLeave', dataType: 'date', sort: true },
      { field: 'fixedRemark', header: 'ShippingStatus.MainTable.Remarks', sort: true },
      { field: 'mergeKey', header: 'ShippingStatus.MainTable.MergeKey', sort: true },
      { field: 'hawbNo', header: 'ShippingStatus.MainTable.HawbNo', sort: true },
      { field: 'frontLineDocStatus', header: 'ShippingStatus.MainTable.FrontLineDocStatus', sort: true },
      { field: 'extraWorkStatus', header: 'ShippingStatus.MainTable.ExtraWorkStatus',sort: true},
    ]

  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();

    // rbac to maintain this page
    var canInPage = this.permissionCodes.includes(this.permissionCode);
    if (!canInPage) {
      // go unAuthorize
      this.routeStateService.navigateTo('/Error/unAuthorize');
    }

    this.dropdownOptionService.getDOStatusOptions()
      .subscribe({
        next: (options: FacilityOptions[]) => {
          this.DOStatusOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
        }
      });

    // get param to auto query
    this.route.queryParams.subscribe((params: Params) => {
      params = Object.values(params);
      if (params.length != 0) {
        const doNos = params[0].split(",");
        this.searchForm.controls["doNos"].setValue(doNos);
        this.searchClick(new Event('click'));
      }
    });

    this.commonDataService.getCodeConverter(this.laasSetting.language, "DropdownList", "FrontLineDocStatus").subscribe({
      next: (options: CodeConverterOptions[]) => {
        this.frontLineDocStatusOptions = options.map(x => ({ label: `${x.codeKey} - ${x.codeDesc}`, value: x.codeKey }));
      }
    });

    await this.getCustomDocTypeOptions();

    this.commonDataService.getCodeConverter(this.laasSetting.language, "DropdownList", "ExtraWorkStatus").subscribe({
      next: (options: CodeConverterOptions[]) => {
        this.extraWorkStatusOptions = options.map(x => ({ label: `${x.codeKey} - ${x.codeDesc}`, value: x.codeKey }));
      }
    });

    this.route.queryParams.subscribe((params: Params) => {
      let routeDoNo = '';
      this.route.queryParams.subscribe((params: Params) => {
        const paramsKeys = Object.keys(params);
        const needParams = ['doNo'];
        if (!needParams.some((key) => paramsKeys.includes(key))) {
          return;
        }
        if (params['doNo']) {
          const parseDoNo = params['doNo'].split(';').filter((parseDoNo: any) => !isNullOrEmpty(parseDoNo));
          if (parseDoNo.length > 0) {
            routeDoNo = parseDoNo;
          }
        }
        if (!isNullOrEmpty(routeDoNo)) {
          params = Object.values(params);
          this.searchForm.controls['doNos'].setValue(routeDoNo);
          this.searchClick(new Event('click'));
        }
      });
    });
  }

  resetForm(event: any): void {
    this.invoiceDt.ngOnInit();
    this.leaveWarehouseDt.ngOnInit();
    this.estimateLeaveDt.ngOnInit();
    this.searchForm.reset({
      orderQueryScope: this.OrderQueryScopeEnum.all,
      orderStatus: 3,
      consigneeCompany: "",
      selectedFacility: [],
      doNos: [],
      estimateLeaveDtStart: startOfDay(new Date()),
      estimateLeaveDtEnd: endOfDay(new Date()),
      invoiceNos: [],
      invoiceDtStart: null,
      invoiceDtEnd: null,
      leaveWarehouseDtStart: null,
      leaveWarehouseDtEnd: null,
      salesCodes: [],
      csr: "",
      ajb: null,
      orgIds: [],
      mergeKeys: [],
      customerPOs: [],
      frontLineDocStatus:  []
    });
  }

  dateOnChange(date: any, type: string) {
    switch (type) {
      case 'invoiceDt':
        this.searchForm.controls['invoiceDtStart'].setValue(date.startDate);
        this.searchForm.controls['invoiceDtEnd'].setValue(date.endDate);
        break;
      case 'leaveWarehouseDt':
        this.searchForm.controls['leaveWarehouseDtStart'].setValue(date.startDate);
        this.searchForm.controls['leaveWarehouseDtEnd'].setValue(date.endDate);
        break;
      case 'estimateLeaveDt':
        this.searchForm.controls['estimateLeaveDtStart'].setValue(date.startDate);
        this.searchForm.controls['estimateLeaveDtEnd'].setValue(date.endDate);
        break;
    }
  }

  searchClick(event: Event): void {
    this.searchParams = copyFormControl(this.searchForm, this.searchParams);

    if (this.searchParams.doNos.length > 0) {
      this.searchParams.estimateLeaveDtStart = null;
      this.searchParams.estimateLeaveDtEnd = null;
    }
    this.isSearchFormOpen = false;
    this.pageInfo.pageIndex = 0;
    this.table.setCurrentPage(0);
    this.getProgressResult();
  }

  /**
   * DO number field add event.
   * @param event p-chips onAdd event.
   */
  onChipsAdd(event: any, formControlName: string): void {
    const value: string = event.value;
    const parsedValues: string[] = value.split('\r\n').map(x => x.trim()).filter(x => isNullOrEmpty(x) === false && x !== '\r\n');

    let doNos: string[] = this.searchForm.controls[formControlName].value;
    doNos.splice(doNos.indexOf(value));
    doNos = doNos.concat(parsedValues);

    this.searchForm.controls[formControlName].setValue(doNos);
  }

  gotoProgress(event: Event, doNo: string): void {
    this.routeStateService.navigateTo(
      '/TransportOperation/ShipmentProgress',
      { doNo: doNo }, true);
  }

  openFileManagement(event: Event): void {
    this.isShowFileManagement = true;
  }

  openTaskDocManagement(): void {
    this.isShowTaskDocManagement = true;
  }


  frontlineDocBtnClick(): void {
    this.fileCategoryForTaskDoc = FileCategory.FrontLine;
    this.canEditTable = true;
    this.canUploadDoc = true;
    this.canConfirm = true;
    this.openTaskDocManagement();
  }

  customerLabelBtnClick(): void {

    if(this.selectedRows.length == 1 ? false : true){ //確認只有選擇一個DO
      this.toastService.warn(this.translateService.instant('ShippingStatus.Warn.ChooseDOMoreThanOne'));
      return;
    }

    this.fileCategoryForTaskDoc = FileCategory.CustomerLabel;
    this.canEditTable = false;
    this.canUploadDoc = true;
    this.canConfirm = true;
    this.openTaskDocManagement();
  }
  async setPageSize(event: any): Promise<void> {
    this.pageInfo.pageSize = event.rows;
  }

  tablePageChange(event: any): void {
    this.pageInfo.pageSize = event.rows;
    this.pageInfo.pageIndex = event.first / this.pageInfo.pageSize;
    this.getProgressResult();
  }

  tableSort(event: any): void {
    this.sortInfo = { property: event.field, direction: event.order };
    this.getProgressResult();
  }

  getProgressResult(): void {
    this.loader.show();

    var dataScopes = getDataScopeByPermission(this.userProfile, this.permissionCode);
    this.searchParams.dataScopes = dataScopes;
    this.searchParams.pageIndex = this.pageInfo.pageIndex;
    this.searchParams.pageSize = this.pageInfo.pageSize;
    this.searchParams.sortInfo = isNullOrEmpty(this.sortInfo) ? null : [this.sortInfo];
    this.searchParams.csr = this.userProfile.employCode;
    this.searchParams.facility = this.laasSetting.facility;

    this.DOService.getProgressResult(this.searchParams).subscribe({
      next: (result: PageResp<ShipmentSearchResult>) => {
        this.results = result.content;
        this.formatFixRemark();

        this.pageInfo.totalRecords = result.totalElements;
        this.pageInfo.totalPages = result.totalPages;
      },
      complete: () => {
        this.selectedRows = [];
        this.loader.hide();
      }
    });
  }

  getReferenceKeys(): string[] {
    return this.selectedRows.map(x => {
      return x.doNo ?? "";
    });
  }

  onShowFileManagement(event: Event): void {
    this.fileManagement.resetComponent();
  }

  formatFixRemark() {
    for (const rowData of this.results) {
      if (rowData.fixedRemark == null) {
        rowData.fixedRemark = null;
      } else {
        rowData.fixedRemark = rowData.fixedRemark.replace('\n', '<br>');
      }
    }
  }

  onShowFrontLineDoc(event: any) {
    this.frontlineDoc.resetComponent(this.getReferenceKeys());
  }
  onHideFrontLineDoc(event: any) {
    this.getProgressResult();
    this.frontlineDoc.doRemindConfirm();
  }

  async getCustomDocTypeOptions(): Promise<LaasOption[]> {
    if (this.customDocTypeOptions.length == 0) {
      const doDocType = await this.commonDataService.getCodeConverter(this.laasSetting.language, "DropdownList", "DeliveryOrderDoc").toPromise();
      const frontLineDocType = await this.commonDataService.getCodeConverter(this.laasSetting.language, "DropdownList", "FrontLineDoc").toPromise();
      const customerLabelDocType = await this.commonDataService.getCodeConverter(this.laasSetting.language, "DropdownList", "CustomerLabelDoc").toPromise();
      this.customDocTypeOptions = this.customDocTypeOptions.concat(doDocType.map((x: any) => {
        return {
          label: x.codeDesc,
          value: x.codeKey
        } as LaasOption
      }));

      this.customDocTypeOptions = this.customDocTypeOptions.concat(frontLineDocType.map((x: any) => {
        return {
          label: `${x.codeDesc}(${this.translateService.instant("ShippingStatus.Button.FrontLineDoc")})`,
          value: x.codeKey
        } as LaasOption
      }));

      this.customDocTypeOptions = this.customDocTypeOptions.concat(customerLabelDocType.map((x: any) => {
        return {
          label: `${x.codeDesc}(${this.translateService.instant("ShippingStatus.Button.CustomerLabel")})`,
          value: x.codeKey
        } as LaasOption
      }));
    }
    return this.customDocTypeOptions;
  }

  optionsDataOnChange(data: any, type: string) {
    switch (type) {
      case 'customer':
        this.searchForm.controls.consigneeCompany.setValue(data);
        break;
      case 'facility':
        console.log(data);
        this.searchForm.controls.selectedFacility.setValue(data);
        break;
      case 'tenantOrg':
        this.searchForm.controls.orgIds.setValue(data);
        break;
      case 'sales':
        this.searchForm.controls.salesCodes.setValue(data);
        break;
    }
  }

}
